import { Link } from '@tanstack/react-router';
import { CircleArrowLeft, UserPlus } from 'lucide-react';
import { useState } from 'react';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '~shared/shadcn/ui/tabs';
import { Button } from '~shared/shadcn/ui/button';

import { GHLUsersTable } from './ghl-users-table';
import { UsersTable } from './users-table';
import { AddUserDialog } from './add-user-dialog';

export const UserManagement = () => {
  const [isAddUserDialogOpen, setIsAddUserDialogOpen] = useState(false);

  return (
    <div>
      <Link to='/dashboard' className='flex w-max items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>User Management</h2>
      </Link>
      <div className='mt-4 border-t pt-8'>
        <Tabs defaultValue='users'>
          <div className='mb-4 flex items-center justify-between'>
            <TabsList>
              <TabsTrigger value='users'>Users</TabsTrigger>
              <TabsTrigger value='ghl-users'>CRM Users</TabsTrigger>
            </TabsList>
            <Button
              variant='secondary'
              onClick={() => {
                setIsAddUserDialogOpen(true);
              }}
            >
              <UserPlus className='mr-2 size-4' />
              Add User
            </Button>
          </div>

          <TabsContent value='users' className='space-y-4'>
            <UsersTable />
          </TabsContent>

          <TabsContent value='ghl-users' className='space-y-4'>
            <GHLUsersTable />
          </TabsContent>
        </Tabs>
      </div>

      <AddUserDialog
        open={isAddUserDialogOpen}
        onOpenChange={setIsAddUserDialogOpen}
      />
    </div>
  );
};
